export enum IncomeLossInsurance {
    None = 'N/A',
    ZeroDays = '0 days',
    TwoDays = '2 days',
    FourteenDays = '14 days',
    ThirtyDays = '30 days',
}
